/**
 * Группирует купленные абонементы по тарифу (SubscriptionPlanId).
 * Суммирует остатки и считает использованные занятия по всем покупкам одного типа.
 */
export function groupSubscriptions(subscriptions) {
    if (!subscriptions?.length) return [];

    const groups = new Map();

    for (const s of subscriptions) {
        const key = s.subscriptionPlanId != null
            ? `plan:${s.subscriptionPlanId}`
            : `name:${s.name}|${s.type}`;

        if (!groups.has(key)) {
            groups.set(key, {
                key,
                subscriptionPlanId: s.subscriptionPlanId,
                name: s.name,
                type: s.type,
                purchaseCount: 0,
                totalLessonsPurchased: 0,
                lessonsLeft: 0,
                lessonsUsed: 0,
                hasLessonPack: false,
                isUnlimited: false,
                activeCount: 0,
                hasActive: false,
                pricePaidTotal: 0,
                firstPurchaseDate: s.purchaseDate,
                latestExpiryDate: null,
                items: []
            });
        }

        const g = groups.get(key);
        g.purchaseCount += 1;
        g.items.push(s);
        g.pricePaidTotal += Number(s.pricePaid) || 0;

        if (s.purchaseDate && new Date(s.purchaseDate) < new Date(g.firstPurchaseDate)) {
            g.firstPurchaseDate = s.purchaseDate;
        }
        if (s.expiryDate) {
            const exp = new Date(s.expiryDate);
            if (!g.latestExpiryDate || exp > new Date(g.latestExpiryDate)) {
                g.latestExpiryDate = s.expiryDate;
            }
        }

        if (s.isActive) {
            g.activeCount += 1;
            g.hasActive = true;
        }

        if (s.totalLessons == null || s.type === 'unlimited') {
            g.isUnlimited = true;
        } else {
            g.hasLessonPack = true;
            const total = Number(s.totalLessons) || 0;
            const left = Math.max(0, Number(s.lessonsLeft) || 0);
            g.totalLessonsPurchased += total;
            g.lessonsLeft += left;
            g.lessonsUsed += Math.max(0, total - left);
        }
    }

    return Array.from(groups.values()).sort(
        (a, b) => new Date(b.firstPurchaseDate) - new Date(a.firstPurchaseDate)
    );
}

export function getGroupedLessonsSummary(groups) {
    const withPack = groups.filter(g => g.hasLessonPack && !g.isUnlimited);
    const lessonsLeft = withPack.reduce((sum, g) => sum + g.lessonsLeft, 0);
    const lessonsPurchased = withPack.reduce((sum, g) => sum + g.totalLessonsPurchased, 0);
    const lessonsUsed = withPack.reduce((sum, g) => sum + g.lessonsUsed, 0);
    const activeGroups = groups.filter(
        g => g.hasActive && (g.isUnlimited || g.lessonsLeft > 0)
    ).length;

    return { lessonsLeft, lessonsPurchased, lessonsUsed, activeGroups };
}
